<template>
  <div class="internet-connection-alert">
    <a-alert type="warning" show-icon closable :message="title" :description="details" @close="handleClose" />
  </div>
</template>

<script>
import { Alert } from 'ant-design-vue'

export default {
  components: {
    'a-alert': Alert
  },
  data() {
    return {
      title: 'Poor Internet Connection!',
      details:
        "Your connection seems unstable or slow, so some features may not work properly. Please check your network, try reconnecting or restarting your router, and we'll reconnect automatically once you're back online."
    }
  },
  methods: {
    handleClose() {
      this.$store.commit('setInternetConnectionState', {
        dismissed: true
      })
    }
  }
}
</script>

<style scoped>
.internet-connection-alert {
  position: fixed;
  top: 24px;
  left: 50%;
  z-index: 1100;
  width: calc(100vw - 32px);
  max-width: 720px;
  transform: translateX(-50%);
  box-shadow: var(--shadow-base);
}
</style>
